export default "__VITE_PUBLIC_ASSET__2f0462ed__"